import { skipToken } from "@apollo/client";
import {
    SavedQuoteDetailsQueryVariables,
    useSavedQuoteDetailsSuspenseQuery,
} from "generated/graphql";
import { notFound } from "next/navigation";

export const useSavedQuote = (
    variables?: Partial<SavedQuoteDetailsQueryVariables>,
) => {
    const { data } = useSavedQuoteDetailsSuspenseQuery(
        variables?.id
            ? {
                  variables: {
                      id: variables.id,
                      language: variables.language ?? "",
                  },
              }
            : skipToken,
    );

    if (
        !data ||
        data.quote?.__typename !== "Quote" ||
        data.quote.businessCode !== process.env.NEXT_PUBLIC_BUSINESS_CODE
    ) {
        return notFound();
    }

    return { quote: data.quote };
};
